import React, { useState, useEffect, useRef } from "react";

import TickIconBlack from "../../assets/img/tick-icon-black.png";
import UploadIcon from "../../assets/img/upload-icon-blue.svg";
import DeletePopup from "./DeletePopup";
import Loader from "./loader";
import $ from "jquery";

import {
  uploadFileViaMultipart,
  removeFile,
} from "../../Actions/uploadFileActions";

import { useDispatch, useSelector } from "react-redux";

import CustomPopUp from "./customPopUp";

function ABUploadEdu(props) {
  const dispatch = useDispatch();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    other: null,
  });
  const [fileLength, setFileLength] = useState();

  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  let {
    name,
    id,
    title,
    record,
    placeholder,
    fieldId,
    isRequired,
    getCount,
    totalCount,
    getUpdatedDocs = () => {}
  } = props;

  //   alert(totalCount);

  const [count, setCount] = useState();

  useEffect(() => {
    setCount(totalCount);
  }, [totalCount]);

  ///////////////////////////////////////////////////////////

  // upload file handle
  const uploadFile = (event) => {
    //console.log(caseCheckId);
    // console.log($("input:file")[0].files.length);
    const chosenFiles = event.target.files;
    console.log("fr",chosenFiles);
    console.log("rewe",event.target.files[0].size);
    for (var i = 0; i < chosenFiles.length; i++) {
      if (event.target.files[i].size > 5242880) {
        alert("File cannot be larger than 5mb");
        return false;
      }
      if (
        chosenFiles[i].name.split(".").pop() == "png" ||
        chosenFiles[i].name.split(".").pop() == "PNG" ||
        chosenFiles[i].name.split(".").pop() == "jpg" ||
        chosenFiles[i].name.split(".").pop() == "JPG" ||
        chosenFiles[i].name.split(".").pop() == "jpeg" ||
        chosenFiles[i].name.split(".").pop() == "JPEG" ||
        chosenFiles[i].name.split(".").pop() == "pdf" ||
        chosenFiles[i].name.split(".").pop() == "PDF"
      ) {
        // props.errorCheck("false");
        // return false;
      } else {
        alert("Invalid file format");
        //props.errorCheck("true");
        return false;
      }
    }

    setFileLength(chosenFiles.length);

    console.log(chosenFiles);

    // const record = {};
    // record.caseCheckId = caseCheckId;
    // record.docId = docId;
    let err_id =
      "err_document_" + record.docId + "_count_" + record.caseCheckId;
    document.getElementById(err_id).innerHTML = "";
    //calling file upload api
    dispatch(uploadFileViaMultipart("check_documents", chosenFiles, record, getUploadCallback));

    // setIsFileUploadedObject((prevState) => ({
    //   ...prevState,
    //   [fieldName]: true,
    // }));
  };

  const getUploadCallback = (data) => {
    console.log("upload data...", data);
    getUpdatedDocs();
  }

  const [isLoading, setIsLoading] = useState(false);

  const uploadStoreData = useSelector((state) => state.savedFileDetails);

  const {
    saveFileUploadData,
    loading: uploadLoad,
    error: uploadError,
  } = uploadStoreData;

  useEffect(() => {
    if (typeof uploadLoad !== "undefined" && uploadLoad !== null) {
      if (uploadLoad === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        // setCount(1);
        //dispatch(getEducation());
        props.reRenderAgain();
      }
    }
  }, [saveFileUploadData]);

  useEffect(() => {
    if (
      typeof saveFileUploadData?.data !== "undefined" &&
      saveFileUploadData?.data !== null &&
      saveFileUploadData?.status == "success"
    ) {
      //    setCount(count + 1);
      //  if(Object.keys(saveFileUploadData.data).length > 0){
      //setCount(Object.keys(saveFileUploadData.data).length)
      //  }
      // setCount(Object.keys(saveFileUploadData.data).length);
      //     alert('#doc_' + record.docId);
      // $('#doc_'+record.docId).addClass("show");
      // $('#doc_'+record.docId).removeClass("hidden");
      // }else{
      //     $('#doc_'+record.docId).removeClass("show");
      //     $('#doc_'+record.docId).addClass("hidden");
      // }
      //dispatch(getEducation());
      //props.reRenderAgain();
    }
  }, [saveFileUploadData, uploadStoreData]);

  // const handleChange = (selectedOption) => {

  //     setReactSelect(selectedOption);

  //     props.selectOption({ "name": name, "value": selectedOption.value, "fieldId": fieldId, "isRequired": isRequired, "err_id": `err-${fieldId}` });
  //     setShowFilterDiv(false);
  //     //setKeyword(selectedOption.name);

  //     if (type === 3) {

  //         inputText.current.value = selectedOption.name;

  //     }

  //     //if this is an auto suggeest and other is selected then do something

  //     if (type === 3 && selectedOption.value === 'other') {

  //         alert("other selected");

  //     }

  //     //if this is an auto suggeest and other is selected then do something

  // };

  const [showModal, setShowModal] = useState(0);

  const closeModal = () => {
    setShowModal(0);
  };

  const reRender = () => {
    props.reRenderAgain();
  };

  const openModal = () => {
    setShowModal(1);
  };

  const [showDeleteModal, setShowDeleteModal] = useState(0);

  const closeDeleteModal = () => {
    setShowDeleteModal(0);
  };

  const openDeleteModal = () => {
    setShowDeleteModal(1);
  };

  const deleteHandler = () => {
    setShowDeleteModal(1);
  };

  const proceedDelete = () => {
    const recordArray = {};
    recordArray.doc_chk = record.caseCheckId;
    recordArray.doc_ids = record.docId;
    recordArray.doc_ref = "all";

    //calling file upload api
    dispatch(removeFile("check_documents", recordArray, removeUpDateCallback));

    props?.reRenderAgain();

    setShowDeleteModal(0);
  };

  const removeUpDateCallback = (data) => {
    getUpdatedDocs();
  }

  useEffect(() => {
    console.log("totalcount...", totalCount)
  },[totalCount])

  return (
    <>
    {isLoading && <Loader />}
    <div className="row mt-3">
        <div className="col-sm-4 col-md-12 col-xl-4">
            <h6 className="">{title}  {isRequired == 1 && <sup className="text-danger">*</sup>}</h6>
            <label htmlFor={id} className="upload-box mb-2 flex-column pt-1 pb-1">
                <img src={UploadIcon} className="mb-1" alt="" />

                <label class="mb-0 text-center" style={{lineHeight: "16px"}}>
                    
                    <div className="right text-right w-100">
                        <div className="position-relative">
                            
                            <input
                                id={id}
                                type="file"
                                style={{ opacity: "0", width: '100%' }}
                                // accept="image/*"
                                multiple
                                onChange={(e) => uploadFile(e)}
                                // accept="image/png, image/jpeg, application/pdf"
                                title="Choose Files"
                                onClick={e => (e.target.value = null)}
                            // params => caseCheckId, docId
                            // onChange={(e) => uploadFile(e)}
                            ></input>



                            {/* <img src={CrossIcon} alt="" className="remove-btn" /> */}
                        </div>

                    </div>
                    <small class="text-center fnt-smi-bld">
                    <span className="text-primary">Click to upload</span>
                     {/* <span className="text-muted">or drag and drop</span> */}
                     <br/>
                     <span className="text-muted">
                      {/* PDF, PNG, JPG, or JPEG  */}
                      <br />
                  {/* Max file size : 5 MB */}
                  </span>
                </small>
                </label>

            </label>

            

        </div>

        {/* {
  "col-auto d-flex align-items-center actions-mbl " + (count >= 1 ? "show" : "hidden")
} */}

        {/* <div className= {
  "col-auto d-flex align-items-center actions-mbl " + (getCount >= 1 ? "show" : "hidden")
} id={`doc_${record.docId}`}> */}

        {totalCount > 0 && (

            <div className={
                "col-sm-4 col-md-12 col-xl-4"
            } id={`doc_${record.docId}`}>
                {/* {(count >= 1) &&  */}
                <>
                <h6>&nbsp;</h6>
                <div className="after-upload-box w-100">
                    {(totalCount > 0) &&
                    <div>
                    <i class="far fa-file mr-3"></i>
                <small className="fnt-smi-bld">{totalCount} files uploaded</small>
                </div>
            }       <div>
                    <i class="fas fa-eye text-muted mr-3 cursor-pointer" onClick={openModal}  data-toggle="tooltip" data-placement="bottom" title="View"></i>
                    <i class="fas fa-trash-alt text-muted text-danger cursor-pointer" onClick={deleteHandler}  data-toggle="tooltip" data-placement="bottom" title="Delete"></i>
                    </div>
                </div>
                </>

                {/* }      */}
            </div>

        )}

    </div>



    {showDeleteModal === 1 &&
        <DeletePopup
            showModalBox={showDeleteModal}
            closePopup={closeDeleteModal}
            title="Delete Images"
            description="Are you sure you want to delete? This action cannot be undone."
            proceedHandler={proceedDelete}
        // record={record}
        />
    }

    {showModal === 1 &&
        <CustomPopUp
            showModalBox={showModal}
            closePopup={closeModal}
            record={record}
            title={title}
            reRenderAgain={reRender}
        />
    }


</>
  );
}

export default ABUploadEdu;
